import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import { TutorialBannerType, TutorialData } from "@domain/tutorial-banner/tutorial-banner-manager";
import styled from "@emotion/styled";
import { VideoPlayer } from "@ui/components/common/video-player";
import { useDimensions } from "@ui/hooks/use-dimensions";
import { useVideo } from "@ui/hooks/use-video";
import { colors } from "@ui/style/colors";
import { Button } from "primereact/button";
import { Dialog, DialogProps } from "primereact/dialog";
import React, { useEffect } from "react";

export interface VideoTutorialDialogProps extends DialogProps {
	tutorial: TutorialData;
	tutorialType: TutorialBannerType;
}

export const TutorialDialog: React.FC<VideoTutorialDialogProps> = props => {
	const { tutorial, tutorialType, onHide, ...otherProps } = props;
	const videoRef = React.useRef<HTMLVideoElement>(null);
	const { openFullScreen } = useVideo();
	const { isMobile } = useDimensions();

	useEffect(() => {
		if (isMobile) {
			openFullScreen();
		}
	}, [isMobile, openFullScreen]);

	const onClose = () => {
		const percentage = videoRef.current
			? Math.round((videoRef.current.currentTime * 100) / videoRef.current.duration)
			: -1;
		analyticsService.trackEvent({
			category: AnalyticsCategory.TUTORIAL,
			action: "videoread",
			params: [tutorialType, percentage],
		});
		onHide();
	};

	return (
		<StyledDialog draggable={false} resizable={false} onHide={onHide} dismissableMask {...otherProps}>
			<CloseButton
				className="p-button-text p-button-rounded ui-button-flat"
				icon="pi pi-times"
				color={colors.white}
				onClick={onClose}
			/>
			<VideoPlayer ref={videoRef} url={tutorial.videoUrl} autoPlay controls style={{ borderRadius: 0 }} />
		</StyledDialog>
	);
};

const StyledDialog = styled(Dialog)`
	width: 684px;
	border-radius: 0;

	.p-dialog-header {
		padding: 0;
		overflow: hidden;

		.p-dialog-header-icons {
			position: absolute;
		}
	}

	.p-dialog-content {
		padding: 0;
		border-radius: 1rem;
	}
`;

const CloseButton = styled(Button)`
	position: absolute;
	z-index: 10;
	top: 0;
	right: 0;
	margin: 12px 8px;

	.p-button-icon {
		color: ${colors.black};
	}
`;
